import { useI18nContext } from '@shared-snap/i18n/i18n-react'
import RectangularButton from 'app/components/buttons/RectangularButton'
import Input from 'app/components/forms/Input'
import LoginLayout from 'app/components/layouts/LoginLayout'
import Loader from 'app/components/loaders/Loader'
import { ModalContainer, ModalOverlay } from 'app/components/styled-components/modal'
import firebase from 'app/utils/firebase'
import { toastErrorStyle } from 'app/utils/styles'
import { Field, Form, Formik } from 'formik'
import type React from 'react'
import { useState } from 'react'
import { toast } from 'react-toastify'
import * as Yup from 'yup'
import { LoginFormWrapper } from './LoginForm/style'
import { containerPadding, containerWidth } from './style'

const LoginEmailPassword = () => {
    const {
        LL: { shared }
    } = useI18nContext()
    const [loading, setLoading] = useState(false)

    const login = async (email: string, password: string) => {
        setLoading(true)
        try {
            await firebase.auth().signInWithEmailAndPassword(email, password)
        } catch (error) {
            console.error(error)
            toast.error(`${error instanceof Error ? error.message : shared.somethingWentWrong()}`, toastErrorStyle)
            setLoading(false)
        }
    }

    return (
        <ModalOverlay>
            <ModalContainer width={containerWidth} padding={containerPadding}>
                <LoginLayout>{loading ? <Loader size="large" /> : <LoginEmailPasswordForm onSubmit={login} />}</LoginLayout>
            </ModalContainer>
        </ModalOverlay>
    )
}

export function LoginEmailPasswordForm({ onSubmit }: { onSubmit: (email: string, password: string) => void }) {
    const {
        locale,
        LL: { login, shared }
    } = useI18nContext()
    const validationSchema = Yup.object().shape({
        email: Yup.string()
            .email(login.invalidEmail())
            .required(shared.errorFieldIsRequired({ field: login.email().toLowerCase() })),
        password: Yup.string().required(shared.errorFieldIsRequired({ field: login.password().toLowerCase() }))
    })
    return (
        <LoginFormWrapper>
            <Formik
                validateOnMount
                key={locale}
                validationSchema={validationSchema}
                initialValues={{ email: '', password: '' }}
                onSubmit={({ email, password }) => onSubmit(email, password)}>
                {({ values, errors, setFieldValue, handleSubmit }) => {
                    const { email, password } = values
                    const disabled = Object.keys(errors).length !== 0

                    return (
                        <Form>
                            <Field
                                name="email"
                                type="email"
                                component={Input}
                                value={email}
                                label={login.email()}
                                placeholder={'your.email@mail.com'}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFieldValue('email', e.target.value)}
                            />
                            <Field
                                name="password"
                                type="password"
                                component={Input}
                                value={password}
                                label={login.password()}
                                placeholder={login.passwordPlaceholder({ isWeb: true })}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFieldValue('password', e.target.value)}
                            />

                            <div className={'btn-wrap'}>
                                <RectangularButton
                                    disabled={disabled}
                                    type="submit"
                                    width={'181px'}
                                    height={'64px'}
                                    onClick={() => handleSubmit()}>
                                    {login.logInBtn()}
                                </RectangularButton>
                            </div>
                        </Form>
                    )
                }}
            </Formik>
        </LoginFormWrapper>
    )
}

export default LoginEmailPassword
